<template>
  <div>
      <v-btn
        icon
        small
        v-on:click="openModal">
        <v-icon>edit</v-icon>
      </v-btn>
    <v-dialog
      v-model="colorModalShow"
      persistent
      max-width="600px"
    >
      <v-card class="mtfont">
        <v-card-title>
          <span>UPDATE COLOR: {{item}} </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                      cols="12"
                      sm="6"
              >
                <v-text-field
                        label="Pantone Code*"
                        v-model="itemData.code"
                        required
                        disabled
                ></v-text-field>
              </v-col>
              <v-col 
                cols="12"
                sm="6">
                <v-text-field
                  label="Hex*"
                  v-model="itemData.hex"
                  required
                ></v-text-field>
              </v-col>


              <v-col
                      cols="12"
                      sm="12">
                <v-text-field
                        label="Name*"
                        v-model="itemData.name"
                        required
                ></v-text-field>
              </v-col>

            </v-row>
            <small>*indicates required field</small>
          </v-container>
          <small :style="'color:'+messageColor">{{dialogMessage}}</small>
        </v-card-text>
        <v-card-actions class="mx-2 pb-4">
          <v-btn
                  class="mtfont"
                  color="black"
                  text

                  @click="$router.push({name: 'Add', params: {item: item}})"
          >
            New Formula
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="mtfont"
            color="black"
            text
            @click="colorModalShow = false"
          >
            Close
          </v-btn>
          <v-btn
            class="mtfont"
            color="black"
            style="color: #fecb39;"
            depressed
            @click="submitForm"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'NewFormulaModal',
    props: ['item'],

    data: () => ({
      colorModalShow: false,
      dialogMessage: '',
      itemData: {
        code: '',
        hex: '',
        name: ''
      }
    }),
    created() {

    },
    mounted() {
    },
    computed: {
      messageColor: function () {
        return ~this.dialogMessage.indexOf('Error')? 'red': 'green'
      }
    },
    methods: {
      openModal() {
        this.colorModalShow = true;
        const allColors = this.$store.getters.getAllColors;
        this.itemData = allColors.find(color => color.code === this.item);
      },
      submitForm() {
        this.$store.dispatch('updateColor', this.itemData).then(response => {
          console.log('COLOR_UPDATE', 'SUCCESS');
        });
        this.colorModalShow = false;
      }
    }
  }
</script>

<style scoped>
</style>